define('view/controller/review/ReviewListView',['require','lib/view/BaseCompositeView','marionette','view/controller/review/ReviewItemView','lib/view/ModalRegion','view/controller/review/ReviewDeleteDialogView'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var Marionette = require('marionette');
    var ReviewItemView = require('view/controller/review/ReviewItemView');
    var ModalRegion = require('lib/view/ModalRegion');
    var ReviewDeleteDialogView = require('view/controller/review/ReviewDeleteDialogView');

    /**
     * Reviews composite view (reviews container)
     *
     * @class ReviewListView
     */
    return Parent.extend({

        template: '#reviews_list_view',
        childView: ReviewItemView,
        childViewContainer: '#sb_reviews_list_items_container',
        childViewOptions: function(model, index) {
            return {
                logged_in: this._reviewModel.get('logged_in'),
                childIndex: index
            }
        },

        collectionEvents: {
            sync: 'render'
        },

        childEvents: {
            'like_review': 'onLikeReview',
            'dislike_review': 'onDislikeReview',
            'delete_review': 'onDeleteReview',
            'dom:refresh': '_onChildDomRefresh'
        },

        _pageId: 'reviews',

        _reviewModel : null,
        _isLogged : null,

        initialize : function () {
            this._reviewModel = this.getOption('reviewModel');
            this.listenTo(this._reviewModel, 'change', this.render);
        },

        onLikeReview: function(view, data) {
            data.model.likeReview();
        },

        onDislikeReview: function(view, data) {
            data.model.dislikeReview();
        },

        onDeleteReview : function(view, data) {
            var instance = this;
            var region = new ModalRegion();
            var dview = new ReviewDeleteDialogView({
                model: data.model
            });
            region.show(dview);

            this.listenTo(dview, 'confirm', function () {
                instance.collection.deleteReview(data.model);
                region.hide();
            });
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            var pageInfo = this.collection.pageInfo();
            return _.extend({}, pageInfo, result);
        }

    });

});
